import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UtilService } from '../../services/util-service/util.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [TranslateModule, CommonModule],
})
export class FooterComponent {
  constructor(private readonly utilService: UtilService) {}

  shouldSingleElementBeDisplayed(translationKey: string): boolean {
    return this.utilService.isTranslationAvailable(translationKey);
  }

  isAtLeastOneTranslationAvailable(translationKeys: string[]): boolean {
    return translationKeys.some(translationKey => this.utilService.isTranslationAvailable(translationKey));
  }
}
